"use client";

import { useEffect } from "react";
import { redirect } from "next/navigation";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Application Error:", error);
    redirect(window.globalConfig.LINKED_PAGES.NOTFOUND);
  }, [error]);

  return <></>;
}
